import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import DataTable from "../../../lib/components/DataTable";
import { moneyFormat } from "../../../utils/moneyFormat";
import pathnames from "../../../constants/pathnames";

const PayoutsDataTable = ({ data = [], isLoading, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  // Column definitions
  const columns = [
    {
      key: "name",
      header: "Referrer Name",
      render: (_, row) => `${row.firstName ?? ""} ${row.lastName ?? ""}`.trim() || row.email,
      filter: "text",
    },
    {
      key: "payoutCount",
      header: "Total Paid Business",
      type: "number",
    },
    {
      key: "lastPayoutDate",
      header: "Last Payout Date",
      type: "date",
      filter: "date",
      format: "Do MMM, YYYY",
    },
    {
      key: "totalPaid",
      header: "Total Amount Paid",
      type: "currency",
      render: (value) => moneyFormat(value, "NGN"),
    },
  ];

  // Row actions: Use <Link> for client-side navigation
  const rowActions = {
    actions: [
      {
        label: "View",
        color: "secondary",
        render: (row) => (
          <Button
            component={Link}
            to={`${pathnames.PAYOUTS}/${row.referrerId}`}
            color="secondary"
          >
            View
          </Button>
        ),
      },
    ],
  };

  return (
    <DataTable
      data={data}
      columns={columns}
      rowActions={rowActions}
      selectable={false}
      isLoading={isLoading}
      getRowId={(row) => row.referrerId || row.accountId}
      page={page}
      pageSize={pageSize}
      totalPages={totalPages}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
};

export default PayoutsDataTable;
